import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { Tag } from 'antd';
import styled from '@xstyled/styled-components';
import { getColor, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerItemContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerItemWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n"])), getSize('padding8'));
var StyledCorrectAnswerLabel = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo14'), function (props) {
  return props.theme.color.fontColorSuccess;
});
var IndexCircle = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  margin-right: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'), getColor('fillIntActive'), getColor('fillBgWhite'), getSize('padding8'), getSize('typo12'));

var renderCorrectAnswerDescription = function renderCorrectAnswerDescription(description) {
  var _description$split;

  if ((description === null || description === void 0 ? void 0 : (_description$split = description.split('|')) === null || _description$split === void 0 ? void 0 : _description$split.length) > 0) {
    var correctAnswers = description.split('|');
    return /*#__PURE__*/_jsx(_Fragment, {
      children: correctAnswers === null || correctAnswers === void 0 ? void 0 : correctAnswers.map(function (part) {
        return /*#__PURE__*/_jsx(Tag, {
          color: "green",
          children: part
        });
      })
    });
  }

  return description;
};

export var AnswerItemComponent = function AnswerItemComponent(_ref) {
  var index = _ref.index,
      correctAnswerLabel = _ref.correctAnswerLabel,
      description = _ref.description;
  return /*#__PURE__*/_jsx(StyledAnswerItemContainer, {
    children: /*#__PURE__*/_jsxs(StyledAnswerItemWrapper, {
      children: [/*#__PURE__*/_jsxs(StyledCorrectAnswerLabel, {
        children: [/*#__PURE__*/_jsx(IndexCircle, {
          children: index
        }), correctAnswerLabel, ":"]
      }), renderCorrectAnswerDescription(description)]
    })
  });
};